import React from 'react'
import ReactDOM from 'react-dom'
import ReactGA from 'react-ga'
import App from 'App'
import 'styles/main.scss'

if (process.env.REACT_APP_GOOGLE_ANALYTICS_ID) {
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID, {
    debug: process.env.NODE_ENV === 'development',
  })
} else {
  console.warn('GA tracking is not initialized...')
}

ReactDOM.render(<App />, document.getElementById('root'))
